import { BookmarkBlockMarkdownAdapterExtension } from '@blocksuite/hive-block-bookmark';
import { CodeBlockMarkdownAdapterExtension } from '@blocksuite/hive-block-code';
import { DatabaseBlockMarkdownAdapterExtension } from '@blocksuite/hive-block-database';
import { DividerBlockMarkdownAdapterExtension } from '@blocksuite/hive-block-divider';
import {
  EmbedFigmaMarkdownAdapterExtension,
  EmbedGithubMarkdownAdapterExtension,
  EmbedIframeBlockMarkdownAdapterExtension,
  EmbedLinkedDocMarkdownAdapterExtension,
  EmbedLoomMarkdownAdapterExtension,
  EmbedSyncedDocMarkdownAdapterExtension,
  EmbedYoutubeMarkdownAdapterExtension,
} from '@blocksuite/hive-block-embed';
import { ImageBlockMarkdownAdapterExtension } from '@blocksuite/hive-block-image';
import { LatexBlockMarkdownAdapterExtension } from '@blocksuite/hive-block-latex';
import { ListBlockMarkdownAdapterExtension } from '@blocksuite/hive-block-list';
import { DocNoteBlockMarkdownAdapterExtension } from '@blocksuite/hive-block-note';
import { ParagraphBlockMarkdownAdapterExtension } from '@blocksuite/hive-block-paragraph';
import { RootBlockMarkdownAdapterExtension } from '@blocksuite/hive-block-root';
import { TableBlockMarkdownAdapterExtension } from '@blocksuite/hive-block-table';

export const defaultBlockMarkdownAdapterMatchers = [
  RootBlockMarkdownAdapterExtension,
  DocNoteBlockMarkdownAdapterExtension,
  EmbedFigmaMarkdownAdapterExtension,
  EmbedGithubMarkdownAdapterExtension,
  EmbedLinkedDocMarkdownAdapterExtension,
  EmbedLoomMarkdownAdapterExtension,
  EmbedSyncedDocMarkdownAdapterExtension,
  EmbedYoutubeMarkdownAdapterExtension,
  EmbedIframeBlockMarkdownAdapterExtension,
  ListBlockMarkdownAdapterExtension,
  ParagraphBlockMarkdownAdapterExtension,
  BookmarkBlockMarkdownAdapterExtension,
  CodeBlockMarkdownAdapterExtension,
  DatabaseBlockMarkdownAdapterExtension,
  TableBlockMarkdownAdapterExtension,
  DividerBlockMarkdownAdapterExtension,
  ImageBlockMarkdownAdapterExtension,
  LatexBlockMarkdownAdapterExtension,
];
